import { apiClient } from '../../api_actions';
import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Button, Modal, Dropdown, Menu } from 'antd';
import { useState, useEffect, useRef } from 'react';

export default function WeeklyReportPage() {  

   const [reportReady, setReportReady] = useState(false);
  const loadReportReadiness = async () => {
    try {
      const result = await apiClient.post('read/report_readiness');
      const reportReady = result.data
      
      setReportReady(reportReady);
    } catch (error) {
      console.error('Failed to load customers:', error);
    }
  };

    // useEffect(() => {
    //   loadReportReadiness()
    // }, []);

  const columns = [
    {
      title: 'User Email',
      dataIndex: ['user','email'],
      key: 'user',
    },
    {
      title: 'Last Sent',
      dataIndex: 'last_sent_unix',
      key: 'last_sent_unix',
      render: (value) => {
        const date = new Date(value);
        // If it's invalid or equals -1 timestamp, show blank
        if (isNaN(date.getTime()) || date.getTime() === -1000) return '';
        if (date.getTime() === 0) return 'Never Sent';
        return date.toLocaleString(); // or format however you prefer
      },

    },
  ];

  const formFields = [
    {
        name: 'user_id',
        label: 'User',
        type: 'select',
        optionsEndpoint: '/read/users',
        optionsLabel: ['email'], // Multiple fields!
        labelSeparator: ' - ',  // Optional, defaults to ' - '
        optionsValue: 'user_id',
        searchable: true,
        rules: [{ required: true }],
    },
  ];

  return (

    <div className='container-wrapper'>
      <div className='report-header'>
        <h2>Weekly Report Users</h2>
          <div className='report-header-actions'>
            {/* <Button
              onClick={async () => {
                try{
                  const res = await apiClient.post("update/authorize_report")
                } catch(error) {
                  console.log(error)
                }
              }}
              disabled={!reportReady}
              
            >
              {reportReady? 'Authorize Report Generation' : 'Report Not Ready'}
              
            </Button> */}

          <ModalEditTable
            createEndpoint="create/webweeklyreportregistration"
            readEndpoint="read/webweeklyreportregistration"
            deleteEndpoint="delete/webweeklyreportregistration"
            columns={columns}
            formFields={formFields}
            //title="Weekly Report Users"
          />
        </div>
      </div>
    </div>
  );
}